<script setup>
import { ref } from 'vue'

import Button from '@components/global/button.vue'
import Input from '@components/global/input.vue'

const processing = ref(false)
const success = ref(false)
const user = ref({})
const errors = ref({})

function submit(form) {
	form.preventDefault()
	if (!processing.value) {
		processing.value = true
		axios
			.post('/api/newsletter', user.value)
			.then(() => {
				errors.value = {}
				processing.value = false
				success.value = true
			})
			.catch((error) => {
				processing.value = false
				success.value = false
				if (error.response.status === 422) errors.value = error.response.data.errors
			})
	}
}
</script>

<template>
	<section>
		<div class="container">
			<div class="relative flex flex-col items-start gap-6 rounded-big border border-border-default p-6 py-8 text-default sm:gap-10 lg:p-14">
				<div class="flex w-full flex-col justify-between gap-8 lg:flex-row lg:items-center">
					<div class="d4 flex flex-row uppercase">
						<span class="font-heading-light">wa</span>
						<span class="font-heading">nt</span>
						<span class="ml-[10px] font-heading-bold">to</span>
						<span class="ml-[10px] font-heading">stay</span>
						<span class="ml-[10px] font-heading-bold">in</span>
						<span class="ml-[10px] font-heading-bold">the</span>
						<span class="ml-[10px] font-heading-bold">loo</span>
						<span class="font-heading-light">p?</span>
					</div>
					<div class="flex items-center gap-2 rounded-md bg-neutral-500/40 p-3" v-if="success">
						<i class="fa-solid fa-check flex h-5 w-5 items-center justify-center rounded-full bg-purple-darker pt-0.5 text-xs" />
						Thank you for subscribing, we'll be in touch soon!
					</div>
					<form class="flex flex-col items-end gap-3 sm:flex-row lg:w-1/2" @submit="submit" v-else>
						<Input class="w-full" placeholder="Insert your email" label="email" type="email" :required="true" max="64" v-model="user.email" :error="errors.email && errors.email[0]" />
						<Button class="default sm:h-12" :processing="processing" :disabled="!user.email || user.email?.length < 5" type="submit">Subscribe</Button>
					</form>
				</div>
				<p class="md text-default/50">
					By subscribing, you agree to receive email newsletters and notifications from Ether. You can unsubscribe anytime using the link in each email, see our
					<router-link :to="{ name: 'page', params: { slug: 'privacy' } }" class="text-purple-dark transition-colors duration-300 hover:text-purple-base">Privacy Policy</router-link>
					for more details.
				</p>
				<i class="icon-button-edge absolute right-2 top-2 -rotate-90 text-[6px] transition-all" />
			</div>
		</div>
		<!-- <a :href="social.link" class="social-item-shadow relative text-default transition-all duration-500 lg:w-full lg:min-w-[320px]" target="_blank">
			<img class="h-10" src="https://cdn.ether.site/images/icons/opensea.svg" :class="social.platform.icon" v-if="social.platform.slug == 'opensea'" />
			<h4 v-else><i :class="social.platform.icon" /></h4>
			<div class="label-medium flex flex-col gap-1 uppercase">
				<span class="text-purple-base" v-if="social.reach">
					{{ social.formatted_reach }}
				</span>
				{{ social.username }}
			</div>
			<i class="icon-button-edge absolute bottom-2 right-2 text-[6px] transition-all" />
		</a> -->
	</section>
</template>
